export default __webpack_public_path__ + "static/media/goat_500.6eef53ae.svg";